'use client';

import Script from 'next/script';
import { useEffect } from 'react';
import { GDPR } from '@/components/GDPR';
import { useSiteContext } from '@/context/SiteContext';
import { events$, ADBLOCK_DETECTED } from '@/utils/events';

export const AdmiralBootstrap = () => {
	const { config: siteConfig } = useSiteContext();
	const isEnabled = siteConfig?.analytics?.providers?.Admiral?.isEnabled;

	useEffect(() => {
		if (!isEnabled) return;

		window.admiral =
			window.admiral ||
			// eslint-disable-next-line func-names
			function (...args: []) {
				(window.admiral.q = window.admiral.q || []).push(args);
			};

		window.admiral(
			'after',
			'measure.detected',
			(user: {
				adblocking: boolean;
				subscribed: boolean;
				whitelisted: boolean;
			}) => {
				if (user.adblocking) {
					events$.next({ type: ADBLOCK_DETECTED });
				}
			},
		);
	}, [isEnabled]);

	// Don't emit the Admiral script at all if it is disabled
	if (!isEnabled) {
		return null;
	}

	return (
		<GDPR
			purposes={[
				'storage',
				'personalization',
				'advertising',
				'measurement/development',
			]}
			vendorId="admiral"
		>
			<Script src="/.api/admiral" />
		</GDPR>
	);
};
